'use strict';

require('./curry.js');
var always = require('./always.js');
require('./_branch.js');
var branch = require('./branch.js');
var id = require('./id.js');
var isString = require('./isString-d8679d99.js');
require('./flatten-a717674f.js');
require('./variadic.js');
require('./compose.js');
require('./_append.js');
require('./append.js');
require('./flip.js');
require('./concatWith-aa95abaf.js');
require('./isArray-fff5bad6.js');
require('./mempty-fb137ec7.js');
require('./concat.js');
var _concatMap = require('./_concatMap.js');

function filter(p, as) {
  var f = branch(p, id, always(''));
  return isString.isString(as) ? _concatMap(f, as) : as.filter(p);
}

module.exports = filter;
